export const BASE_URL = 'https://dummyjson.com/';

export const ENDPOINTS = {
  CATEGORIES: 'products/category-list',
  PRODUCTS: 'products',
  BY_CATEGORY: 'products/category/',
  SEARCH_FORM: 'products/search'
};

